import { useEffect, useId } from 'react';

import { labels } from '../labels.js';

interface ConfirmSheetProps {
  title: string;
  message: string;
  confirmLabel: string;
  onConfirm: () => void;
  onCancel: () => void;
}

/** Bottom sheet confirmation, in place of window.confirm. */
export function ConfirmSheet({ title, message, confirmLabel, onConfirm, onCancel }: ConfirmSheetProps) {
  const titleId = useId();

  useEffect(() => {
    const onKey = (e: KeyboardEvent) => { if (e.key === 'Escape') onCancel(); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onCancel]);

  return (
    <div className="modal-backdrop" onMouseDown={(e) => { if (e.target === e.currentTarget) onCancel(); }}>
      <div role="alertdialog" aria-modal="true" aria-labelledby={titleId} className="modal">
        <div className="modal__header">
          <div>
            <h2 id={titleId} className="modal__title">{title}</h2>
            <p className="modal__description">{message}</p>
          </div>
        </div>
        <div className="modal__footer">
          <button type="button" className="btn-ghost" onClick={onCancel} autoFocus>{labels.common.back}</button>
          <button type="button" className="btn-danger btn-danger--solid" onClick={onConfirm}>{confirmLabel}</button>
        </div>
      </div>
    </div>
  );
}
